const initState = {
  address: null,
  network: process.env.REACT_APP_NETWORK,
  // network: 4,
  stakeLoading: false,
  stakeTransactionMessage: { message: "", hash: "" },
  unStakeLoading: false,
  toastState: false,
  toastMessage: "",
  themeMode: "light",
  sideDrawer: false,
};

const LayoutReducer = (state = initState, action) => {
  switch (action.type) {
    case "checkWeb3":
      return {
        ...state,
        address: action.payload.address,
        network: action.payload.network,
      };
    case "checkWeb3React":
      return {
        ...state,
        // network: action.payload.chainId,
        address: action.payload.account,
      };
    case "onStakeLoad":
      return {
        ...state,
        stakeLoading: action.payload,
      };
    case "onStakeMessage":
      return {
        ...state,
        stakeTransactionMessage: action.payload,
      };
    case "onUnStakeLoad":
      return {
        ...state,
        unStakeLoading: action.payload,
      };
    case "onToastOpen":
      return {
        ...state,
        toastMessage: action.payload.message,
        toastState: action.payload.open,
      };
    case "onHandleToastClose":
      return {
        ...state,
        toastState: action.payload,
      };

    case "onThemeModeChanged":
      return {
        ...state,
        themeMode: action.payload,
      };

    case "onSideDrawerClicked":
      return {
        ...state,
        sideDrawer: !state.sideDrawer,
      };

    case "LOGOUT_APP":
      return {
        ...initState,
        address: state.address,
      };

    default:
      return state;
  }
};

export default LayoutReducer;
